import { defineMessages } from 'react-intl';

const messages = defineMessages({
  siteName: { id: 'G20 Portal', defaultMessage: 'G20 Portal' },
});

export default messages;
